export default "__VITE_ASSET__D3nMF4Jl__"